import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { AverageOrderStatisticsQuery } from '../../../../generated/graphql';
import { BillsIcon, Card, CardContent, CardTitle, MoneyIcon, OrdersIcon, ProductsIcon } from '../../../../ui-kit';
import { usePriceService } from '../../../../utils/hooks/priceService';
import DetailsRow from './DetailsRow';

type AverageOrderStatisticsViewProps = Pick<AverageOrderStatisticsQuery, 'averageOrderStatistics'>;

const AverageOrderStatisticsView = ({ averageOrderStatistics }: AverageOrderStatisticsViewProps) => {
    const { t } = useTranslation();
    const { priceService } = usePriceService();

    const { averageBillAmount, billCount, itemsPerOrder, orderCount } = averageOrderStatistics;

    const itemsPerOrderRounded = priceService.roundWithPrecision(itemsPerOrder, 1);

    return (
        <Card fullHeight>
            <CardContent padding={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <CardTitle>{t('Other statistics')}</CardTitle>
                    </Grid>
                    <Grid item xs={12}>
                        <DetailsRow
                            icon={OrdersIcon}
                            title={t('{{count}} order', { count: orderCount }) as string}
                            subtitle={t('total')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DetailsRow
                            icon={MoneyIcon}
                            title={priceService.toLocaleString(averageBillAmount)}
                            subtitle={t('average bill')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DetailsRow
                            icon={BillsIcon}
                            title={t('{{count}} bill', { count: billCount }) as string}
                            subtitle={t('total')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DetailsRow
                            icon={ProductsIcon}
                            title={t('{{count}} item', { count: itemsPerOrderRounded }) as string}
                            subtitle={t('average per order')}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default AverageOrderStatisticsView;